import CountUp from 'react-countup';
import { useInView } from 'react-intersection-observer';

export const AnimatedCounter = ({ 
  end, 
  suffix = '', 
  prefix = '', 
  duration = 2.5,
  decimals = 0 
}) => {
  const { ref, inView } = useInView({
    threshold: 0.3,
    triggerOnce: true,
  });

  return (
    <span ref={ref} data-testid="animated-counter">
      {inView ? (
        <CountUp
          start={0}
          end={end}
          duration={duration}
          suffix={suffix}
          prefix={prefix}
          decimals={decimals}
          separator=","
        />
      ) : (
        `${prefix}0${suffix}`
      )}
    </span>
  );
};
